import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import axios from 'axios';
import { environment } from 'src/environments/environment';
import { WorkflowService } from '../services/workflow/workflow.service';
import { PayeeCasesService } from './payee-cases.service';
import {
  TransferInstructions,
  TransferInstructionsDialogComponent,
} from './transfer-instructions-dialog/transfer-instructions-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class StartPaymentService {
  private dialog = inject(MatDialog);
  private workflow = inject(WorkflowService);
  private payeeCasesService = inject(PayeeCasesService);

  showError(error: unknown): void {
    this.workflow.showTransitionError(error);
  }

  async payWithCard(caseId: string): Promise<void> {
    const url = `${environment.baseUrl}/api/case/${caseId}/start-with-card-payment`;
    const result = await axios.get<string>(url);
    window.location.href = result.data;
  }

  async payWithCredit(caseId: string): Promise<boolean> {
    try {
      await axios.post(
        `${environment.baseUrl}/api/case/${caseId}/start-with-credit`,
      );
      if (this.payeeCasesService.stage.value === 'draft') {
        this.payeeCasesService.stage.next('ongoing');
      } else {
        await this.payeeCasesService.setCases();
      }
      return true;
    } catch (error: unknown) {
      this.showError(error);
      return false;
    }
  }

  async requestProForma(caseId: string): Promise<TransferInstructions | null> {
    try {
      const result = await axios.post<TransferInstructions>(
        `${environment.baseUrl}/api/case/${caseId}/start-with-transfer`,
      );
      if (this.payeeCasesService.stage.value === 'draft') {
        this.payeeCasesService.stage.next('ongoing');
      } else {
        this.workflow.afterWorkflow.next(result.data);
      }
      return result.data;
    } catch (error: unknown) {
      this.showError(error);
      return null;
    }
  }

  showTransferInstructions(instructions: TransferInstructions): void {
    this.dialog.open<TransferInstructionsDialogComponent, TransferInstructions>(
      TransferInstructionsDialogComponent,
      {
        data: instructions,
        autoFocus: false,
      },
    );
  }
}
